export const initialInvoiceState = {
    customer: null,
    products: [],
    orders: [],
    invoice: [],
    productLists :[],
    discount: 0,
    tax: 0,
    selectedProduct: '',
    quantity: 1,
  };
  